// state.js

export default {
    remoteConfigs: []
};
